import gapsSlice from './gapsSlice';

export { default as gapsOp } from './operations';

export default gapsSlice;
